import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import { ThemeProvider } from './components/theme-provider';
import { useAuthStore } from './app/store/authStore';

// Initialize auth state from storage
const initializeAuth = (): void => {
    try {
        const storageValue = localStorage.getItem('auth-storage');
        if (storageValue) {
            const persistedState = JSON.parse(storageValue);
            if (persistedState?.state?.token) {
                useAuthStore.setState({
                    token: persistedState.state.token,
                    isAuthenticated: true
                });
            }
        }

        // Also check for authToken in localStorage for backward compatibility
        const authToken = localStorage.getItem('authToken');
        if (authToken && !useAuthStore.getState().isAuthenticated) {
            useAuthStore.setState({
                token: authToken,
                isAuthenticated: true
            });
        }
    } catch (e) {
        console.error('Failed to initialize auth state:', e);
    }
};

initializeAuth();

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider defaultTheme="dark" storageKey="pwa-ui-theme">
            <App />
        </ThemeProvider>
    </React.StrictMode>
);
